import NamedStorage from "./NamedStorage";

export default class LevelConfigStorage {
  private mStorage: NamedStorage;
  constructor() {
    this.mStorage = new NamedStorage("LevelConfig");
  }

  public GetLevelsCompleted(): string[] {
    return this.mStorage.GetArray("LevelsCompleted");
  }

  public AddLevelCompleted(levelName: string) {
    const levels = this.GetLevelsCompleted();
    if (levels.indexOf(levelName) < 0) {
      this.mStorage.StoreInArray("LevelsCompleted", levelName);
    }
  }
}
